export enum LabelType {
  Undefined = 0,
  DangerousGoods = 1,
  HazardSubstance = 2,
}
